

export const frontMatter = {
	custom_edit_url: '/501',
	last_update: {
		author: 'Google Translate'
	}
};
export const contentTitle = 'Tipkovnice';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-sl-docusaurus-plugin-content-docs-current-resources-keyboards-md-0dc.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Windows",
  "id": "windows",
  "level": 3
}, {
  "value": "Mac",
  "id": "mac",
  "level": 3
}, {
  "value": "Linux",
  "id": "linux",
  "level": 3
}, {
  "value": "Android",
  "id": "android",
  "level": 3
}, {
  "value": "Druge platforme",
  "id": "other-platforms",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "tipkovnice",
        children: "Tipkovnice"
      })
    }), "\n", _jsx(_components.h3, {
      id: "windows",
      children: "Windows"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "http://tyflonet.com/siciliano/klaviatury",
        children: "http://tyflonet.com/siciliano/klaviatury"
      })
    }), "\n", _jsx(_components.h3, {
      id: "mac",
      children: "Mac"
    }), "\n", _jsx(_components.p, {
      children: "OPRAVILO: dodajte povezave"
    }), "\n", _jsx(_components.h3, {
      id: "linux",
      children: "Linux"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Razširjena latinica MS na mednarodnih latiničnih tipkovnicah (kot je hrvatska v različici unicodeus)."
      }), "\n", _jsx(_components.li, {
        children: "Polna cirilična tipkovnica je na standardni ukrajinski tipkovnici."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "android",
      children: "Android"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "http://usachov.eu/g",
        children: "http://usachov.eu/g"
      })
    }), "\n", _jsx(_components.h3, {
      id: "other-platforms",
      children: "Druge platforme"
    }), "\n", _jsx(_components.p, {
      children: "Če za vašo platformo ni tipkovnice, lahko poskusite uporabiti nekaj vgrajenih razporeditev tipkovnice:"
    }), "\n", _jsxs(_components.p, {
      children: ["Za ", _jsx(_components.strong, {
        children: "medslovansko latinico"
      }), " abecedo:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "češčina (standardna, delno etimološka)"
      }), "\n", _jsx(_components.li, {
        children: "hrvaški (izvzeto)"
      }), "\n", _jsx(_components.li, {
        children: "Srbija (oproščeno)"
      }), "\n", _jsx(_components.li, {
        children: "slovenski (izvzeto)"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Za ", _jsx(_components.strong, {
        children: "medslovansko cirilico"
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "srbščina (izvzeto, brez \"Ы\")"
      }), "\n"]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

